/**
 * Set `VITE_USE_MOCK_API=true` in `.env`, `.env.local`, or `.env.development` (see repo `frontend/.env.development`).
 * Also works when starting with: `VITE_USE_MOCK_API=true npm run dev` or `npm run dev:mock`.
 */
function readMockFlag(): boolean {
  const v = import.meta.env.VITE_USE_MOCK_API
  if (v == null || v === '') return false
  const s = String(v).trim().toLowerCase()
  return s === 'true' || s === '1' || s === 'yes' || s === 'on'
}

export const USE_MOCK_API = readMockFlag()
